<template>
    <div class="setting">
        <div class="settingItem">
            <TitleRow text="基本信息"/>
            <CellGroup :border="false">
                <Cell title="头像" title-class="cellTitle">
                    <img :src="userInfo.avatar ? userInfo.avatar : require('../../../assets/images/logo.png') " class="userIcon" alt="">
                </Cell>
                <Cell title="用户名" :value="userInfo.username" value-class="cellValue" title-class="cellTitle"/>
                <Cell title="姓名" :value="userInfo.name" value-class="cellValue" title-class="cellTitle" is-link
                      :to="`/editInfo/name?value=${userInfo.name}`"/>
                <Cell title="身份证号" :value="userInfo.selfCard ? userInfo.selfCard : '还为未设置'" value-class="cellValue"
                      :to="`/editInfo/selfCard?value=${userInfo.selfCard}`" title-class="cellTitle" is-link/>
                <Cell title="账户类型" :value="userInfo.agentLevel.levelCode === 'F' ? '网点' : '代理商'"
                      value-class="cellValue" title-class="cellTitle"/>
                <Cell title="地址" :value="userInfo.selfArea" value-class="cellValue addressCell" title-class="cellTitle"
                      is-link :to="`/editInfo/selfArea?value=${userInfo.selfArea}`"/>
                <template v-if="!isStore">
                    <Cell title="最大设置分润" :value="`${userInfo.permitBrokerage}%`" value-class="cellValue"
                          title-class="cellTitle"/>
                    <Cell title="文案二维码" title-class="cellTitle" is-link @click="showUploader = true">
                        <img src="../../../assets/images/ic_qrCode.png" class="qrCode" alt="">
                    </Cell>
                </template>
            </CellGroup>
        </div>
        <div class="settingItem">
            <TitleRow text="安全设置"/>
            <CellGroup :border="false">
                <Cell title="手机号" :value="userInfo.mobile" to="/updateMobile" value-class="cellValue"
                      title-class="cellTitle" is-link/>
                <Cell title="密码" value="重置" :to="`/editInfo/resetPS`" value-class="cellValue" title-class="cellTitle"
                      is-link/>
                <Cell title="提现方式" value="设置" value-class="cellValue" title-class="cellTitle" is-link to="/drawMode"/>
            </CellGroup>
        </div>
        <div class="settingItem">
            <TitleRow text="其他"/>
            <CellGroup :border="false">
                <Cell title="注册时间" :value="userInfo.createTime" value-class="cellValue" title-class="cellTitle"/>
                <Cell title="最后登录时间" :value="userInfo.lastLoginTime" value-class="cellValue" title-class="cellTitle"/>
            </CellGroup>
        </div>
        <Popup v-model="showUploader" class="uploaderView" closeable>
            <Uploader :after-read="afterRead" :before-read="beforeRead">
                <div class="uploaderImgView">
                    <img v-if="userInfo.urlPath" :src="userInfo.urlPath" class="uploaderImg" alt="">
                    <Icon v-else name="plus"/>
                </div>
                <p v-if="userInfo.urlPath">点击图片上传二维码</p>
            </Uploader>
        </Popup>
    </div>
</template>

<script>
    /*
    * 设置
    * */
    import TitleRow from './components/TitleRow'
    import {Cell, CellGroup, Popup, Uploader, Icon} from 'vant';
    import {updateImageUrl, editInfoApi} from "../../../api/editInfo";
    import {mapState} from 'vuex';

    export default {
        name: "Setting",
        components: {
            TitleRow,
            Cell,
            CellGroup,
            Popup,
            Uploader,
            Icon
        },
        data() {
            return {
                showUploader: false,
                fileList: []
            }
        },
        computed: {
            ...mapState(['isStore', 'userInfo'])
        },
        methods: {
            // 返回布尔值
            beforeRead(file) {
                if (file.size > 1000000) {
                    this.toast({
                        text: '图片大小不能1M',
                        icon: 'warning'
                    });
                    return false;
                }
                return true;
            },
            afterRead(file) {
                updateImageUrl({file: file.file}).then(res => {
                    editInfoApi({qrCodePath: res}).then(_ => {
                        this.$store.dispatch('getUserInfo');
                    })
                })
            }
        }
    }
</script>

<style lang='less' scoped>
    .setting {
        min-height: 100vh;
        padding-top: 2.67vw;
        padding-bottom: 0.1vw;
        background-color: #f7f7f7;
        box-sizing: border-box;

        .settingItem {
            width: 93.87vw;
            margin: 0 auto 4vw;
            padding: 0 3vw;
            background-color: #ffffff;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2.67vw;
            box-sizing: border-box;

            .userIcon {
                float: right;
                width: 6.53vw;
                height: 6.53vw;
                border-radius: 50%;
            }

            .qrCode {
                float: right;
                width: 5.33vw;
                height: 5.2vw;
            }

            .cellValue {
                font-size: 3.2vw;
                color: #333333;

                &.addressCell {
                    flex: 4;
                }
            }

            .cellTitle {
                font-size: 3.2vw;
                color: #333333;
            }

            .van-cell {
                align-items: center;
                padding: 0;
                height: 9.73vw;
                box-sizing: border-box;

                &:not(:last-child)::after {
                    left: 0;
                }
            }
        }

        .uploaderView {
            width: 65vw;
            height: 65vw;
            border-radius: 2.67vw;

            .uploaderImgView {
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 45vw;
                height: 45vw;
                margin: 10vw 0 0 10vw;
                border: 1px dashed #ebedf0;
                font-size: 24px;
                color: #969799;
                border-radius: 2.67vw;

                .uploaderImg {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }

            p {
                text-indent: 6vw;
                text-align: center;
                font-size: 14px;
                line-height: 7.5vw;
                color: #333;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/setting/Setting.vue